import { t } from "ttag";

import type { Invoice } from "@/shared/domains";
import { PAYMENT_STATUS } from "@/shared/domains";

/**
 * @deprecated Use `BILLING_FREQUENCY` from "/shared/domains"
 */
export const DURATION_IN_MONTHS = {
  MONTHLY: 1,
  QUARTERLY: 3,
  SEMI_ANNUALLY: 6,
  ANNUALLY: 12,
} as const;

export const PAYMENT_STATUS_COLOR = {
  [PAYMENT_STATUS.FAILED]: "red",
  [PAYMENT_STATUS.PROCESSING]: "yellow",
  [PAYMENT_STATUS.SUCCESS]: "green",
} as const;

export const getPaymentStatusLabel = (status: Invoice["status"]) => {
  return {
    [PAYMENT_STATUS.FAILED]: t`Failed`,
    [PAYMENT_STATUS.PROCESSING]: t`Processing`,
    [PAYMENT_STATUS.SUCCESS]: t`Completed`,
  }[status];
};
